import { Injectable } from '@angular/core';
import {Observable} from "rxjs/Rx";
import {IResponse, remittanceFilter, settlementAccResponse, settlementPreviewProp} from "../../../interfaces/iresponse";
import {ApiService} from "../../api/api.service.";
import { filterSettlement} from 'src/app/super-users/settlement/settlement.component';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class SuperAdminService {

  constructor(private api: ApiService) { }

  public getAllSuperAgents(status: string, page: number, perPage: number): Observable<IResponse> {
    let queryParams = new HttpParams();
    queryParams = queryParams.set('page', page.toString()).set('perPage', perPage);
    if(!status){
      queryParams = queryParams.set('all', '1');
    }else{
      queryParams = queryParams.set('status', status);
    }
    return this.api.getRequest('admin', 'super-agents', queryParams ).map( (res: IResponse) => {
      return res;
    });
  }
  public getDashboard(): Observable<IResponse> {
    return this.api.getRequest('dashboard', null).map( (res: IResponse) => {
      return res;
    });
  }

  public createSuperAgents(data): Observable<IResponse> {
    return this.api.postRequest('admin', 'super-agents', data).map( (res: IResponse) => {
      return res;
    });
  }
  public updateSuperAgents(data, id): Observable<IResponse> {
    return this.api.putRequest('admin', 'super-agents/'+id, data).map( (res: IResponse) => {
      return res;
    });
  }
  public createAgent(data): Observable<IResponse> {
    return this.api.postRequest('agents', null, data).map( (res: IResponse) => {
      return res;
    });
  }
  public createPaymentChannel(data): Observable<IResponse> {
    return this.api.postRequest('payment_channels', null, data).map( (res: IResponse) => {
      return res;
    });
  }
  public createBeneficiary(data): Observable<IResponse> {
    return this.api.postRequest('beneficiaries', null, data).map( (res: IResponse) => {
      return res;
    });
  }
  public updateBeneficiary(data, id): Observable<IResponse> {
    return this.api.putRequest('beneficiaries', id, data).map( (res: IResponse) => {
      return res;
    });
  }
  public updateAgent(data, id): Observable<IResponse> {
    return this.api.putRequest('agents', id, data).map( (res: IResponse) => {
      return res;
    });
  }
  public updatePaymentChannel(data, id): Observable<IResponse> {
    return this.api.putRequest('payment_channels', id, data).map( (res: IResponse) => {
      return res;
    });
  }
  public createZone(data): Observable<IResponse> {
    return this.api.postRequest('zones', null, data).map( (res: IResponse) => {
      return res;
    });
  }
  public updateZone(data, id): Observable<IResponse> {
    return this.api.putRequest('zones', id, data).map( (res: IResponse) => {
      return res;
    });
  }
  public getAllAgents(page?: number , perPage?: number): Observable<IResponse> {
  const params = new HttpParams()
    .set('page', page?.toString()).set('perPage', perPage?.toString());

    return this.api.getRequest('agents', null, params).map((res: IResponse) => {
      return res;
    });
  }

  public getAllAgentsForFilter(): Observable<IResponse> {
    const params = new HttpParams()
    .set('paginate', 'false');

    return this.api.getRequest('agents', null, params).map((res: IResponse) => {
      return res;
    });
  }

  public getSuperAgentAgent(filter, superAgentId): Observable<IResponse> {
   // if(filter.)
    if(!filter || (filter.approved !== 0 && filter.approved !== 1)) {
      return this.api.getRequest('super-agent', 'agents/' + superAgentId).map( (res: IResponse) => {
        return res;
      });
    } else {
      return this.api.getRequest('super-agent', `agents/${superAgentId}?status=${ (filter.approved === 1) ? 'approved' : 'not_approved'}`).map( (res: IResponse) => {
        return res;
      });
    }
   /* return this.api.getRequest('super-agent', `agents/${superAgentId}?status=${ (filter.approved === 1) ? 'approved' : 'not_approved'}`).map( (res: IResponse) => {
      return res;
    });*/
  }
  public getAllRiders(): Observable<IResponse> {
    return this.api.getRequest('riders', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getAllRides(): Observable<IResponse> {
    return this.api.getRequest('rides', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getBanks(): Observable<IResponse> {
    return this.api.getRequest('banks', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getTransactionTypes(): Observable<IResponse> {
    return this.api.getRequest('transaction_types', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getBeneficiaries(): Observable<IResponse> {
    return this.api.getRequest('beneficiaries', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getSharingFormulas(): Observable<IResponse> {
    return this.api.getRequest('sharingFormulars', null).map( (res: IResponse) => {
      return res;
    });
  }
  public getPaymentChannels(): Observable<IResponse> {
    return this.api.getRequest('payment_channels', null).map( (res: IResponse) => {
      return res;
    });
  }
  public toggleSuperAgentStatus(SuperAgentId: number, action: 'enable' | 'disable'): Observable<IResponse>{
    return this.api.postRequest('admin', 'super-agents/toggle-status',{
      super_agent_id: SuperAgentId,
      action: action
    }).map((res: IResponse) => {
      return res
    });
  }

  public toggleAgentStatus(agentId: number, action: 'enable' | 'disable'): Observable<IResponse> {
    return this.api.postRequest('agents', 'toggle-status',{
      agent_id: agentId,
      action: action
    }).map((res: IResponse) => {
      return res
    });
  }

  public toggleZoneStatus(zoneId: number, action: 'enable' | 'disable'): Observable<IResponse> {
    return this.api.postRequest('zones', 'toggle-status',{
      zone_id: zoneId,
      action: action
    }).map((res: IResponse) => {
      return res;
    });
  }

  public deleteSuperAgent(id): Observable<IResponse> {
    return this.api.deleteRequest('admin', 'super-agents/' + id ).map( (res: IResponse) => {
      return res;
    });
  }
  public deleteBeneficiary(id): Observable<IResponse> {
    return this.api.deleteRequest('beneficiaries', id ).map( (res: IResponse) => {
      return res;
    });
  }
  public deleteZone(id): Observable<IResponse> {
    return this.api.deleteRequest('zones', id ).map( (res: IResponse) => {
      return res;
    });
  }
  public deleteAgent(id): Observable<IResponse> {
    return this.api.deleteRequest('agents/' + id, null ).map( (res: IResponse) => {
      return res;
    });
  }
  public deletePaymentChannel(id): Observable<IResponse> {
    return this.api.deleteRequest('payment_channels', id ).map( (res: IResponse) => {
      return res;
    });
  }

  public postSettlementAccount(payload:{account_number: string,bank_code:string}):Observable<settlementAccResponse>{
    return this.api.postRequest('zones/settlement', 'name-enquiry', payload ).map(response=> response.data as settlementAccResponse);
  }

  public settlementPreview(settlementFilter: filterSettlement, page: number, perPage: number){
    let queryParams 
    let param = new HttpParams();
    param = param.set('page', page.toString()).set('perPage', perPage.toString());
    if(settlementFilter.from === '' && settlementFilter.to === ''){
      return;
    }else{
      if(settlementFilter.to !== '' && settlementFilter.from === ''){
        queryParams = `?to=${encodeURIComponent(settlementFilter.to)}`;
      }
      if(settlementFilter.from !== '' && settlementFilter.to !== '')
      queryParams = `?from=${encodeURIComponent(settlementFilter.from)}&to=${encodeURIComponent(settlementFilter.to)}`
    }
    return this.api.getRequest('admin/settlements', `preview${queryParams ? queryParams : ''}`, param).
    map(response => response.data);
  }

  public runSettlement(data:{transaction_ref: string}){
    return this.api.postRequest('admin/settlements','run', data ).map(response=>response);
  }

  public settlementHistory(page: number, perPage: number){
    const param = new HttpParams().set('page', page.toString()).set('perPage', perPage.toString())
    return this.api.getRequest('admin', 'settlements', param).map(response => {
      const {data} = response.data;
      let processedDate;
      data.map((d)=>{
        processedDate = new Date(d['processed_at']).
        toLocaleDateString('en-US', {month: 'long', day: 'numeric', year: 'numeric'} );
        return [...data, d['processed_at'] = processedDate]
      })
      return data;
    });
  }

  public getSettlementDetails(id: string){
    return this.api.getRequest('admin', `settlements/${id}`).map(response=>response);
  }

  public refreshStatus(id: number){
    return this.api.postRequest('admin/settlements', `${id}/refresh`, null).map(response=>response);
  }

  public getRemittances(filterBy: remittanceFilter){
    let params = [];
    Object.entries(filterBy).forEach(([key, _])=>{
      if(filterBy[key] === '' || filterBy[key]?.length === 0 || filterBy[key] === 0 || filterBy[key] === null){
        return
      }else{
        params.push(`${[key]}=${encodeURIComponent(filterBy[key])}`);
      }
    })
    const queryParams = `?${params.join('&')}`;
    return this.api.getRequest('admin', `remittances${queryParams}`).map((res)=>{
      const {data} = res.data;
      const remmitances = data.map((r)=>{
        const dateTime = new Date(r.date_time).toLocaleDateString('en-Us', {
          month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric'
        })
        return {...r, date_time: dateTime};
      })
      return remmitances;
    })
  }
}

